var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "informations" },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "", row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { lg6: "" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", [_vm._v("Dados da Funcionalidade")]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { staticClass: "mb-2", attrs: { wrap: "", row: "" } },
                        [
                          _c("v-flex", { attrs: { lg6: "" } }, [
                            _c("h4", { staticClass: "secondary--text" }, [
                              _vm._v(
                                "\n                Titulo\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "grey--text darken-4 mt-4" },
                              [_vm._v(_vm._s(_vm.feature.title))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { lg6: "" } }, [
                            _c("h4", { staticClass: "secondary--text" }, [
                              _vm._v("\n                Nome\n              "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "grey--text darken-4 mt-4" },
                              [_vm._v(_vm._s(_vm.feature.name))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { lg6: "" } }, [
                            _c("h4", { staticClass: "secondary--text" }, [
                              _vm._v("\n                Tipo\n              "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "grey--text darken-4 mt-4" },
                              [_vm._v(_vm._s(_vm.feature.type))]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { lg6: "" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", [_vm._v("Actions")]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { staticClass: "mb-2", attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { lg6: "" } },
                            [
                              _c("h4", { staticClass: "secondary--text" }, [
                                _vm._v(
                                  "\n                Actions\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.feature.actions,
                                function (action, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "grey--text darken-4 mt-4",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(action.title) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }